module.exports = __webpack_public_path__ + "img/Model11x5x28.49be71ea.png";